import React from "react";
import { motion } from "framer-motion";

export const QuestionCard = ({ question }) => (
  <motion.div
    initial={{ scale: 0.7, opacity: 0, rotateX: -30 }}
    animate={{ scale: 1, opacity: 1, rotateX: 0 }}
    transition={{ type: "spring", stiffness: 90, damping: 14, delay: 0.1 }}
    className="relative w-full max-w-3xl bg-[#FFD700] border-4 border-[#111111] shadow-brutal-lg p-8 md:p-12 mx-auto"
    data-testid="question-card"
  >
    <span className="absolute -top-4 left-6 bg-[#111111] text-[#FFD700] font-mono-debate font-bold uppercase tracking-[0.25em] text-xs px-3 py-1">
      ★ The Debate ★
    </span>
    <p
      className="font-anton uppercase text-3xl md:text-5xl leading-tight text-center text-[#111111]"
      data-testid="debate-question"
    >
      {question}
    </p>
  </motion.div>
);
